import React, { useEffect, useRef, useState } from 'react';
import { SlideDown } from 'react-slidedown';
import 'react-slidedown/lib/slidedown.css';
import cls from '@utils/css-select';
import styles from './styles.scss';
import classNames from 'classnames';

const cx = cls(styles);

interface QaData {
	question: string;
	answer: string | React.ReactNode;
}

type Props = {
	className?: string;
	listData: QaData[];
	transData: any;
	isHtml?: boolean;
	slideDown?: boolean;
	isPosition?: boolean;
	onChange?: (data: QaData, index: number) => void;
};

function List(props: Props) {
	const { listData, transData, isHtml = false, slideDown = true, isPosition = false, onChange } = props;
	const ListItem = (props: { className?: string; itemIndex: number; itemData: QaData; slideDown: boolean }) => {
		const [slideDown, setSlideDown] = useState(props.slideDown);
		function handleSlideDownClick() {
			setSlideDown(!slideDown);
			!slideDown && onChange && onChange(props.itemData, props.itemIndex);
		}

		return (
			<div className={cx('list-item-container', props.className, { [`is-position`]: slideDown && isPosition })}>
				<p className={cx('item-title')}>
					<i className={cx('list-index')}>{`${transData.q}${props.itemIndex}`}</i>
					{!isHtml ? (
						<span className={cx('content')}>{props.itemData.question}</span>
					) : (
						<span className={cx('content')} dangerouslySetInnerHTML={{ __html: props.itemData.question }} />
					)}
					<i
						className={cx('slide-down-switch', 'iconfont', 'btn_faqs_dropdown', { 'slide-down': slideDown })}
						onClick={handleSlideDownClick}></i>
				</p>
				<SlideDown className={cx('faq-slide-down')}>
					{slideDown &&
						(isHtml ? (
							<div className={cx('detail')} dangerouslySetInnerHTML={{ __html: props.itemData.answer as string }} />
						) : (
							<div className={cx('detail')}>{props.itemData.answer}</div>
						))}
				</SlideDown>
			</div>
		);
	};

	return (
		<ul className={cx('list-wrap')}>
			{listData.map((item, index) => {
				return (
					<li key={index}>
						<ListItem itemIndex={index + 1} itemData={item} slideDown={slideDown ? index === 0 : slideDown} />
					</li>
				);
			})}
		</ul>
	);
}

export default List;
